var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-scrollbar",
    { attrs: { "wrap-class": "scrollbar-wrapper" } },
    [
      _c(
        "el-menu",
        {
          attrs: {
            "show-timeout": 200,
            "default-active": _vm.$route.path,
            "background-color": "#fafafa",
            "text-color": "#595961",
            "active-text-color": "#595961",
          },
        },
        [
          _vm.currRouterData.meta.group
            ? _vm._l(_vm.currRouterData.meta.group, function (group, idx) {
                return _c(
                  "div",
                  { key: idx, staticClass: "subnav" },
                  [
                    _c("p", { staticClass: "subnav_title" }, [
                      _vm._v(_vm._s(group.title)),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.currRouterData.children, function (route) {
                      return route.meta.groupCode === group.code
                        ? _c("sidebar-item", {
                            key: route.name,
                            attrs: {
                              item: route,
                              "base-path": _vm.currRouterData.path,
                            },
                          })
                        : _vm._e()
                    }),
                  ],
                  2
                )
              })
            : _vm._l(_vm.currRouterData.children, function (route) {
                return _c("sidebar-item", {
                  key: route.name,
                  attrs: { item: route, "base-path": _vm.currRouterData.path },
                })
              }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }